module.exports = __webpack_public_path__ + "media/images/psma-7e364f8a2189617def1a2b8a913d531b.svg";